import {SET_SIGNALR_CONNECTION, SET_SIGNALR_CONNECTION_ID} from "@/store/modules/signalRDeviceCommand/mutations";
import SignalRDeviceCommandsWebhook from "@/api/SignalRDeviceCommandsWebhook";

const signalR = new SignalRDeviceCommandsWebhook()

const setSignalRConnection = ({ commit }) => {
    const connection = signalR.connect()
    connection.handleDeviceCommandStateChanged()
    connection.startListen()
    commit(SET_SIGNALR_CONNECTION, connection);
};

const setSignalRConnectionId = ({ commit }, payload) => {
    commit(SET_SIGNALR_CONNECTION_ID, payload);
};

const clearSignalRConnection = async ({ commit }) => {
    // await signalR.disconnect()
    commit(SET_SIGNALR_CONNECTION, null);
    commit(SET_SIGNALR_CONNECTION_ID, null);
};

export default {
    setSignalRConnection,
    setSignalRConnectionId,
    clearSignalRConnection
};
